import PreviewDrawerContent from '@/components/Drawers/PreviewDrawer/PreviewDrawerContent';
import PreviewDrawerHeader from '@/components/Drawers/PreviewDrawer/PreviewDrawerHeader';
import { showToast } from '@/features/toast/toastSlice';
import { useObjectContext } from '@/hooks/useObjectContext';
import { usePreviewMode } from '@/hooks/usePreviewMode';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const PreviewDrawer = () => {
	const dispatch = useDispatch();

	const { isPreviewMode, closePreview, isClientPreviewMode } = usePreviewMode();

	const { clientRow, dealRow, isLoadingDeal, isClientLoading } = useObjectContext();

	const shouldShowInvalidDeal =
		isPreviewMode && !isClientPreviewMode && !isLoadingDeal && !dealRow;
	const shouldShowInvalidClient = isClientPreviewMode && !isClientLoading && !clientRow;

	const shouldShowInvalid = isClientPreviewMode ? shouldShowInvalidClient : shouldShowInvalidDeal;

	const title = isClientPreviewMode ? 'client' : 'deal';

	useEffect(() => {
		if (!shouldShowInvalid) return;

		dispatch(
			showToast({
				id: `no-${title}-found-preview`,
				message: `No ${title} found`,
				error: true,
				autohide: true,
			}),
		);
		closePreview();
	}, [shouldShowInvalid, closePreview, dispatch, isClientPreviewMode]);

	return (
		<FolioDrawer
			open={isPreviewMode}
			onClose={closePreview}
			size='narrow'
			backdropClose={false}
		>
			{shouldShowInvalid ? (
				<Typography>{`No ${title} found`}</Typography>
			) : (
				<>
					<PreviewDrawerHeader />
					<PreviewDrawerContent />
				</>
			)}
		</FolioDrawer>
	);
};
PreviewDrawer.displayName = 'PreviewDrawer';
export default PreviewDrawer;
